import React from 'react';

export default function EditSection({ editRef, title, onCancel, onSave, isEditSaveInProgress, children, loadingComponent }) {
	const loadingShield = loadingComponent || (
		<div className="loading-shield" style={{ position: 'absolute', zIndex: '90' }}>
			<i className="fa fa-spinner fa-spin fa-fw loading-icon" style={{ width: '1em', position: 'absolute' }}></i>
		</div>
	);
	return (
		<div className="panel panel-primary edit-expanded">
			<div className="panel-heading">
				<h3 className="panel-title"><strong>{title}</strong></h3>
			</div>
			<div className="panel-body" style={{ position: 'relative' }}>
				{isEditSaveInProgress && loadingShield}
				{children}
				<div className=" text-right">
					<button className="btn btn-secondary rounded-pill" onClick={onCancel}>
						Cancel
					</button>
					<span className="me-2"></span>
					<button className="btn btn-primary rounded-pill" onClick={onSave}>
						Save
					</button>
				</div>
			</div>
		</div>
	);
}
